

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { EarningsSetup } from "../../components/EarningsSetup/EarningsSetup";


export const EarningsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Earnings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Earnings", navigateTo: "/company/earnings/list" },
        { text: "Create Earnings", navigateTo: "/company/earnings/setup" }
      ]}
      mainContents={<EarningsSetup />}
    />
  );
};
